import { render, staticRenderFns } from "./standIndoor.vue?vue&type=template&id=3f19338e&scoped=true"
import script from "./standIndoor.vue?vue&type=script&lang=js"
export * from "./standIndoor.vue?vue&type=script&lang=js"
import style0 from "./standIndoor.vue?vue&type=style&index=0&id=3f19338e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f19338e",
  null
  
)

export default component.exports